import React, { ReactNode } from "react";

interface ErrorTextProps {
  children?: ReactNode;
  className?: string;
}

const ErrorText: React.FC<ErrorTextProps> = ({ children, className = "" }) => {
  if (!children) return null;

  return <p className={`text-red-500 mb-4 ${className}`}>{children}</p>;
};

export default ErrorText;
